import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import PresentationBuilder from '../components/PresentationBuilder'

const PresentationBuilderPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="AI Presentation Builder"
        subtitle="Create complete presentations with AI assistance"
      />
      
      <div className="page-content">
        <PresentationBuilder />
      </div>
    </AppContainer>
  )
}

export default PresentationBuilderPage